import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { EASE } from "@/components/Reveal";

const KEY = "acs_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
    const reopen = () => setVisible(true);
    window.addEventListener("acs:open-cookies", reopen);
    return () => window.removeEventListener("acs:open-cookies", reopen);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.5, ease: EASE }}
          className="fixed bottom-0 inset-x-0 z-[70] bg-slate-900 border-t border-slate-700"
          data-testid="cookie-banner"
        >
          <div className="max-w-7xl mx-auto px-6 sm:px-12 py-5 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8">
            <p className="flex-1 text-sm text-slate-300 leading-relaxed">
              Nous utilisons des cookies techniques nécessaires au fonctionnement du site et des
              traceurs pour mesurer l'audience de façon anonyme. Aucune donnée n'est revendue à
              des tiers.
            </p>
            <div className="flex items-center gap-6 shrink-0">
              <button
                onClick={() => choose("accepted")}
                data-testid="cookie-accept-button"
                className="bg-white text-slate-900 text-sm font-medium rounded-full px-5 py-2.5 hover:bg-slate-200 transition-colors duration-300"
              >
                Tout accepter
              </button>
              <button
                onClick={() => choose("declined")}
                data-testid="cookie-decline-button"
                className="text-sm text-slate-400 underline underline-offset-4 hover:text-white transition-colors duration-300"
              >
                Continuer sans accepter
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
